/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Pricing_Feature_Own_BotInputs */



/**
* | output |
* | --- |
* | "A dedicated bot under your name" |
*
* @param {Pricing_Feature_Own_BotInputs} inputs
* @param {{ locale?: "en" | "ru" }} options
* @returns {LocalizedString}
*/
export const pricing_feature_own_bot = /** @type {((inputs?: Pricing_Feature_Own_BotInputs, options?: { locale?: "en" | "ru" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Pricing_Feature_Own_BotInputs, { locale?: "en" | "ru" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "ru") return /** @type {LocalizedString} */ ("Собственный бот под вашим именем")
	return /** @type {LocalizedString} */ ("A dedicated bot under your name")
});